var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      ref: "logoutForm",
      staticClass: "logout-wrapper",
      attrs: { method: "post" },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.logout($event)
        }
      }
    },
    [
      _c(
        "button",
        {
          staticClass: "btn btn-secondary nav-menu-button",
          attrs: { type: "submit" }
        },
        [_vm._v(_vm._s(_vm.$t("Btn_Logout")))]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }